import * as zod from 'zod';

import { TCPOffsetOption } from '@sb/motion-planning';
import { Step } from '@sb/remote-control/types';
import { PayloadState } from '@sb/routine-runner/types/PayloadState';

import { ActuateGripperStepDatabase } from './ActuateGripperStepDatabase';

export namespace EnableGripperStepDatabase {
  export const name = 'Enable gripper';
  export const description = 'Enable a gripper for use';
  export const { deviceKinds } = ActuateGripperStepDatabase;
  export const librarySection = Step.LibrarySection.InterfaceWithMachines;
  export const librarySort = '2';
  export const argumentKind = 'EnableGripper';

  export const Arguments = zod.object({
    argumentKind: zod.literal(argumentKind),
    deviceID: zod.string().optional(),
    payload: PayloadState.nullable().default(null),
    waitForGripperToInitialize: zod.boolean().default(false),
    setActiveTooltip: zod.boolean().default(false),
    activeTooltipOption: TCPOffsetOption.optional(),
  });

  export type Arguments = zod.infer<typeof Arguments>;

  export const toRoutineRunner: Step.ToRoutineRunner = ({
    stepConfiguration: { args },
    stepData,
  }) => {
    if (args?.argumentKind !== argumentKind) {
      throw new TypeError(`Expected argument kind ${argumentKind}`);
    }

    return {
      ...stepData,
      stepKind: 'EnableGripper',
      args: {
        deviceID: args.deviceID,
        payload: args.payload,
        waitForGripperToInitialize: args.waitForGripperToInitialize,
        setActiveTooltip: args.setActiveTooltip,
        activeTooltipOption: args.activeTooltipOption,
      },
    };
  };
}

EnableGripperStepDatabase satisfies Step.StepKindInfo;
